<template>
  <div id="app">
    <!-- to manage the panels the bootstrap NAV-TABS component is used, 
    and they are linked to a logic that allows to hide and activate each panel as necessary with Jquery ...
    For the client this was not enough, and required the implementation of a progress bar. 
    Every time a panel is changed, the progress bar must be updated. 
    To maintain the previously implemented logic, the Boostrap component is still used but the tabs are hidden-->
    <ul v-show="true" class="nav nav-tabs mb-3">
      <li class="nav-item">
        <a
          href="#information"
          data-toggle="tab"
          aria-expanded="true"
          class="nav-link active"
        >
          <i class="mdi mdi-home-variant d-lg-none d-block mr-1" />
          <span class="d-lg-block">Asset Information</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#description"
          data-toggle="tab"
          aria-expanded="false"
          class="nav-link"
        >
          <i class="mdi mdi-account-circle d-lg-none d-block mr-1" />
          <span class="d-lg-block">Description and characteristics</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#multimedia"
          data-toggle="tab"
          aria-expanded="false"
          class="nav-link"
        >
          <i class="mdi mdi-settings-outline d-lg-none d-block mr-1" />
          <span class="d-lg-block">Multimedia</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#fractionalization"
          data-toggle="tab"
          aria-expanded="false"
          class="nav-link"
        >
          <i class="mdi mdi-settings-outline d-lg-none d-block mr-1" />
          <span class="d-lg-block">Fractionalization</span>
        </a>
      </li>
    </ul>

    <!-- PANELS THAT RENDER EVERY VIEW -->
    <div class="container text-left tab-content">
      <div id="information" class="tab-pane show active">
        <AssetInformation
          :current="stepProgressBarParams.currentStep"
          @update="updateCurrent"
        />
      </div>
      <div id="description" class="tab-pane">
        <AssetDescription
          :current="stepProgressBarParams.currentStep"
          @update="updateCurrent"
        />
      </div>
      <div id="multimedia" class="tab-pane">
        <AssetMultimedia
          :current="stepProgressBarParams.currentStep"
          @update="updateCurrent"
        />
      </div>
      <div id="fractionalization" class="tab-pane">
        <AssetFractionalization
          :current="stepProgressBarParams.currentStep"
          @update="updateCurrent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AssetInformation from './AssetInformation';
import AssetDescription from './AssetDescription';
import AssetMultimedia from './AssetMultimedia';
import AssetFractionalization from './AssetFractionalization';
export default {
  name: 'Main',
  components: {
    AssetInformation,
    AssetDescription,
    AssetMultimedia,
    AssetFractionalization,
  },
  props: {
    current: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      stepProgressBarParams: {
        totalSteps: 6,
        currentStep: 1,
        stepTitles: [
          'Asset Information',
          'Description and characteristics',
          'Multimedia and Social Networks',
          'Asset Fractionalization',
          'Dividends Distribution',
        ],
      },
      current_tab: 1,
    };
  },
  watch: {
    'stepProgressBarParams.currentStep': function(val) {
      this.$refs.stepProgressBarCompRef.changeCurrentStep(val);
      this.current_tab = val;
    },
  },
  mounted() {
    this.$nextTick(function() {
      var vueThis = this;
      window.$('#next').click(function() {
        if (
          vueThis.stepProgressBarParams.currentStep >
          vueThis.stepProgressBarParams.totalSteps
        ) {
          return;
        }
        vueThis.stepProgressBarParams.currentStep += 1;
      });
    });
  },
  methods: {
    // Custom Event method that runs every time
    // that the children change the state of the bar
    // to update it
    updateCurrent(newData) {
      if (
        this.stepProgressBarParams.currentStep <=
        this.stepProgressBarParams.totalSteps
      )
        this.stepProgressBarParams.currentStep = newData;
    },
  },
};
</script>

<style lang="scss"></style>
